import {IExtensionInstance} from '@baidu/realtime-editor';
import {EntryTooltipContentFactory} from './render/EntryTooltipContent';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';
import {FlexBuilderType} from './constant';
import {getIsSdkPage} from '@/kuSdk/view/DocViewAll/utils/isSdkPage';
import {getConfigs} from '@/kuSdk/view/DocViewAll/utils/configs';
import {pluginFactory} from './factory';

const {isInGrayPromise: isMatchFlexBuilder} = initGray(
    GRAY_RELEASE_KEYS.flexBuilder
);
const {isInGrayPromise: isMatchFlexBuilderLite} = initGray(
    GRAY_RELEASE_KEYS.flexBuilderLite
);

export default pluginFactory({
    viewNode: {
        title: '随心搭',
        getQuote: () => {
            return '随心搭';
        },
    },
    insert: {
        title: '随心搭 Beta',
        keywords: ['sxd', '随心搭', 'suixinda'],
        tip: EntryTooltipContentFactory({
            title: '随心搭 Beta',
            flexBuilderType: FlexBuilderType.frontend,
        }),
        hook: (config: IExtensionInstance['insert'], utils: any) => {
            let hasTrigUpdate = false;
            isMatchFlexBuilder().then((inGray) => {
                if (inGray && !hasTrigUpdate) {
                    hasTrigUpdate = true;
                    utils?.update?.(config);
                }
            });
            isMatchFlexBuilderLite().then((inGray) => {
                if (inGray && !hasTrigUpdate) {
                    hasTrigUpdate = true;
                    utils?.update?.(config);
                }
            });
        },
        toolbar: {
            enable: () => {
                if (getIsSdkPage()) {
                    return !!getConfigs().flexBuilder;
                }
                return true;
            },
        },
    },
    flexBuilderType: FlexBuilderType.frontend,
});
